import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Property } from '@vsolv/packages/properties/domain';
import { PropertyInputComponent } from '../../abstract-property-input.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-text-input-field',
  templateUrl: './form-field.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TextInputFieldComponent,
    },
    { provide: NG_VALIDATORS, useExisting: TextInputFieldComponent, multi: true },
  ],
})
export class TextInputFieldComponent extends PropertyInputComponent {
  @Input() override property!: Property.TextModel;
}
